import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
    signal,
    input,
    output,
} from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { ITagModel } from '@fi-shared/models';
import { Observable } from 'rxjs';
import { UserService } from '@fi-app/user/user.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-tag-list-table-container',
    templateUrl: './tag-list-table-container.component.html',
    styleUrls: ['./tag-list-table-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-tag-list-table-container' },
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', border: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false,
})
export class TagListTableContainerComponent {
    public items = input<ITagModel[]>([]);
    public selectedItems = input<ITagModel[]>([]);
    public loading = input<boolean>(false);
    @Input() isHeaderRowShown: boolean = true;
    @Input() sortColumn: string;
    @Input() matSortDirection: 'desc' | 'asc';
    @Input() onDataChanged$: Observable<void>;
    @Input() totalCount: number;
    public matSortChange = output<Sort>();
    public checkedItemsChange = output<ITagModel[]>();
    public scrollToBottom = output<void>();

    @ViewChild(MatSort, { static: false }) matSort: MatSort;

    readonly paddingLeftChildItems: string = '16px';

    constructor(
        private userService: UserService,
        private stateService: FiStateService,
    ) {}

    onSelectionChanged($event: ITagModel[]) {
        this.checkedItemsChange.emit($event);
    }

    onSortChanged($event: Sort) {
        this.matSortChange.emit($event);
    }

    onScrollToBottom() {
        // use setTimeout because of loading might not be finished in FiDataSourceBase
        setTimeout(() => this.scrollToBottom.emit());
    }

    getItemTagRolesNames(tag: ITagModel): string {
        return tag.ConnectedRoles.map((role) => role.Name).join(', ');
    }

    navigateToTagViewer($event, tagId: number) {
        $event.stopPropagation();
        this.stateService.go(FiStateNames.Tag.View, { Id: tagId });
    }

    openUserViewDialog($event: MouseEvent, userId: number) {
        $event.stopPropagation();
        this.userService.openUserViewDialog(userId);
    }
}
